import axiosInstance from "../../../config/axios";

export const createStory = async (data: any) => {
    const formData = new FormData();
    formData.append('mediaType', data.mediaType);
    formData.append('media', data.media);
    formData.append('caption', data.caption);
    // Visibility window (ISO). Backend defaults: start = now, expiry = start + 24h.
    if (data.startDate) formData.append('startDate', data.startDate);
    if (data.expiresAt) formData.append('expiresAt', data.expiresAt);
    if (Array.isArray(data.items) && data.items.length > 0) {
        const itemNumbers = data.items.map((it: any) => Number(it));
        formData.append('items', JSON.stringify(itemNumbers));
    }
    const response = await axiosInstance.post('/distrubutor/stories', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getStory = async () => {
    const response = await axiosInstance.get('/distrubutor/stories');
    return response.data;
};

export const getStoryById = async (id: string) => {
    const response = await axiosInstance.get(`/distrubutor/stories/${id}`);
    return response.data;
};

export const updateStory = async (id: string, data: any) => {
    const response = await axiosInstance.put(`/distrubutor/stories/${id}`, data);
    return response.data;
};

// Edit Story form: multipart so a replacement media file can ride along (optional).
// Only the fields passed are changed; without `media` the current file is kept.
export const editStory = async (id: string, data: {
    caption?: string;
    items?: number[];
    startDate?: string;
    expiresAt?: string;
    media?: File | null;
    mediaType?: 'image' | 'video';
}) => {
    const formData = new FormData();
    if (data.caption !== undefined) formData.append('caption', data.caption);
    if (data.items !== undefined) formData.append('items', JSON.stringify(data.items.map(Number)));
    if (data.startDate) formData.append('startDate', data.startDate);
    if (data.expiresAt) formData.append('expiresAt', data.expiresAt);
    if (data.media) {
        formData.append('media', data.media);
        if (data.mediaType) formData.append('mediaType', data.mediaType);
    }
    const response = await axiosInstance.put(`/distrubutor/stories/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

// Copy a story into a new one (new id → fresh views and analytics). Media is reused
// unless `media` is passed; caption / items / window come from the form.
export const duplicateStory = async (id: string, data: {
    caption?: string;
    items?: number[];
    startDate?: string;
    expiresAt?: string;
    media?: File | null;
    mediaType?: 'image' | 'video';
}) => {
    const formData = new FormData();
    if (data.caption !== undefined) formData.append('caption', data.caption);
    if (data.items !== undefined) formData.append('items', JSON.stringify(data.items.map(Number)));
    if (data.startDate) formData.append('startDate', data.startDate);
    if (data.expiresAt) formData.append('expiresAt', data.expiresAt);
    if (data.media) {
        formData.append('media', data.media);
        if (data.mediaType) formData.append('mediaType', data.mediaType);
    }
    const response = await axiosInstance.post(`/distrubutor/stories/${id}/duplicate`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const deleteStory = async (id: string) => {
    const response = await axiosInstance.put(`/distrubutor/deleteStories/${id}`);
    return response.data;
};

export const getInactiveStories = async (params?: { page?: number; limit?: number }) => {
    const response = await axiosInstance.get('/distrubutor/inactiveStories', { params });
    return response.data;
};